import {
    ADD_SURVEY_MIDDLE,
    EDIT_SURVEY_MIDDLE,
    LIST_SURVEY_MIDDLE,
    VIEW_SURVEY_MIDDLE,
    DELETE_SURVEY_MIDDLE,

    SURVEY_MIDDLE_SUCCESS,
    SURVEY_MIDDLE_ERROR,
  
  } from "./actionTypes"
  
  // add SURVEY_MIDDLE
  export const addSurveyMiddle = (data, history, callback) => {
    return {
      type: ADD_SURVEY_MIDDLE,
      payload: { data, history, callback }
    }
  }
  
  // edit SURVEY_MIDDLE
  export const editSurveyMiddle = (data, id, callback) => {
    return {
      type: EDIT_SURVEY_MIDDLE,
      payload: { data, id, callback },
    }
  }
  
  // list SURVEY_MIDDLE
  export const listSurveyMiddle = (data, callback) => {
    return {
      type: LIST_SURVEY_MIDDLE,
      payload: { data, callback },
    }
  }
  
  // view SURVEY_MIDDLE
  export const viewSurveyMiddle = (data, history) => {
    return {
      type: VIEW_SURVEY_MIDDLE,
      payload: { data, history },
    }
  }
  
  // delete SURVEY_MIDDLE
  export const deleteSurveyMiddle = (data, callback) => {
    return {
      type: DELETE_SURVEY_MIDDLE,
      payload: { data, callback },
    }
  }
  
  
  export const surveyMiddleSuccess = message => {
    return {
      type: SURVEY_MIDDLE_SUCCESS,
      payload: message,
    }
  }
  
  export const surveyMiddleError = message => {
    return {
      type: SURVEY_MIDDLE_ERROR,
      payload: message,
    }
  }
  